import RestDataSource from "./restdatasource";
import { Global_var } from "../global/global_var";

export const FeedbackService = {
    PostFeedback,
    getConcernTypeList
}


function PostFeedback(feedback, fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_POSTFEEDBACK;
    return new RestDataSource(url, fnError).Store(feedback, res => {
        if (res != null) {
            if (res.headers["jtitoken"] != null) {
                localStorage.setItem("jti-token", res.headers.jtitoken);
            }
            fn(res.data);
        }
    });
}
function getConcernTypeList(fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_CONCERN_TYPE_LIST;
    return new RestDataSource(url, fnError).GetData(res => {
        if (res != null) {
            if (res.headers["jtitoken"] != null) {
                localStorage.setItem("jti-token", res.headers.jtitoken);
            }
            fn(res.data);
        }
    });
}

  